import { Component, EventEmitter, Output, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as LivespaceActions from '../../state/livespace/livespace.actions';
import {
  selectLivespaceConnecting,
  selectLivespaceConnectError,
  selectLivespaceConnected,
} from '../../state/livespace/livespace.selectors';

@Component({
  selector: 'app-livespace-connect-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './livespace-connect-dialog.component.html',
})
export class LivespaceConnectDialogComponent implements OnInit, OnDestroy {
  @Output() closed = new EventEmitter<void>();
  @Output() connected = new EventEmitter<void>();

  form: FormGroup;
  connecting$ = this.store.select(selectLivespaceConnecting);
  error$ = this.store.select(selectLivespaceConnectError);
  showSecret = false;

  private connectSub: Subscription;

  constructor(private fb: FormBuilder, private store: Store) {
    this.form = this.fb.group({
      subdomain: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9-]+$/)]],
      api_key: ['', Validators.required],
      api_secret: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    // Listen for successful connection to close dialog
    this.connectSub = this.store.select(selectLivespaceConnected).subscribe((connected) => {
      if (connected) {
        this.connected.emit();
        this.close();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.connectSub) {
      this.connectSub.unsubscribe();
    }
  }

  connect(): void {
    if (this.form.valid) {
      const { subdomain, api_key, api_secret } = this.form.value;
      this.store.dispatch(LivespaceActions.livespaceConnect({ subdomain, api_key, api_secret }));
    }
  }

  close(): void {
    this.closed.emit();
  }

  toggleSecret(): void {
    this.showSecret = !this.showSecret;
  }
}
